export const CLASS_PREFIX = 'nplayer_';

export const CLASS_PLAYER = 'nplayer';

export const EVENT = {
  ENTER_FULLSCREEN: 'EnterFullscreen',
  EXIT_FULLSCREEN: 'ExitFullscreen',
  WEB_ENTER_FULLSCREEN: 'WebEnterFullscreen',
  WEB_EXIT_FULLSCREEN: 'WebExitFullscreen',
  DURATION_CHANGE: 'DurationChange',
  RATE_CHANGE: 'RateChange',
  AFTER_INIT: 'AfterInit',
  PLAY: 'Play',
  PAUSE: 'Pause',
  ENDED: 'Ended',
  WAITING: 'Waiting',
  STALLED: 'Stalled',
  CANPLAY: 'Canplay',
  LOADED_METADATA: 'LoadedMetadata',
  ERROR: 'Error',
  SEEKED: 'Seeked',
  TIME_UPDATE: 'TimeUpdate',
  VOLUME_CHANGE: 'VolumeChange',
  PROGRESS: 'Progress',
  ENTER_PIP: 'EnterPip',
  EXIT_PIP: 'ExitPip',
  LOADING_SHOW: 'LoadingShow',
  LOADING_HIDE: 'LoadingHide',
  MOUNTED: 'Mounted',
  UPDATE_SIZE: 'UpdateSize',
  BEFORE_DISPOSE: 'BeforeDispose',
  UPDATE_OPTIONS: 'UpdateOptions',
  OPEN_EDGE: 'OpenEdge',
  CONTROL_SHOW: 'ControlShow',
  CONTROL_HIDE: 'ControlHide',
  CONTROL_ITEM_UPDATE: 'ControlItemUpdate',
  BP_CHANGE: 'BpChange',
} as const;
